import React from 'react';
import Modal from 'react-modal';

Modal.setAppElement('#root');

const ReducirMoraModal = ({
  show,
  onClose,
  selectedCuota,
  selectedPrestamo,
  formData,
  errors,
  handleInputChange,
  handleConfirmAction,
  formatDate
}) => {
  if (!selectedCuota || !selectedPrestamo) return null;

  return (
    <Modal
      isOpen={show}
      onRequestClose={onClose}
      contentLabel="Reducir Mora de Cuota"
      className="modal-panel modal-panel-sm p-6"
      overlayClassName="modal-overlay"
    >
      <h2 className="modal-title mb-4 text-red-600">
        Reducir Mora - Cuota #{selectedCuota.numero_cuota}
      </h2>
      <p className="modal-text mb-4">
        Préstamo #{selectedPrestamo.idPrestamo} - Fecha de vencimiento: {formatDate(selectedCuota.fecha_vencimiento)}
      </p>
      <p className="modal-text mb-4">
        Mora actual: S/ {(parseFloat(selectedCuota.mora) || 0).toFixed(2)}
      </p>

      <div className="mb-4">
        <label className="modal-label">
          Porcentaje de Reducción (%)
        </label>
        <input
          type="number"
          name="porcentaje_reduccion"
          value={formData.porcentaje_reduccion || ''}
          onChange={handleInputChange}
          className={`modal-input ${
            errors.porcentaje_reduccion ? 'border-red-500' : 'border-gray-300'
          }`}
          placeholder="Ingrese porcentaje (1-100)"
          min="1"
          max="100"
        />
        {errors.porcentaje_reduccion && (
          <p className="text-red-500 text-xs mt-1">{errors.porcentaje_reduccion}</p>
        )}
      </div>

      <div className="modal-actions">
        <button
          onClick={onClose}
          className="btn-modal-neutral"
        >
          Cancelar
        </button>
        <button
          onClick={handleConfirmAction}
          className="btn-modal-danger"
        >
          Aplicar Reducción
        </button>
      </div>
    </Modal>
  );
};

export default ReducirMoraModal;
